import { render } from "./PIN.vue?vue&type=template&id=4829f780&scoped=true"
import script from "./PIN.vue?vue&type=script&lang=js"
export * from "./PIN.vue?vue&type=script&lang=js"

import "./PIN.vue?vue&type=style&index=0&id=4829f780&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4829f780"

export default script